import query from '../utils/grappa';
import {
  ArticlePageQuery,
  ArticlePageQueryVariables,
  SearchQuery,
  SearchQueryVariables,
} from '@elevio-kb/queries/dist/types';
import { ARTICLE_QUERY, ARTICLE_SEARCH } from '@elevio-kb/queries';

export const ARTICLES_FETCH_SIZE = 1000;

export async function fetchArticle(articleId: string, languageId: string) {
  const res = await query<ArticlePageQuery, ArticlePageQueryVariables>(
    ARTICLE_QUERY,
    {
      articleId,
      pageUrl: window.location.toString(),
      languageId,
      paging: {
        first: ARTICLES_FETCH_SIZE,
        offset: 0,
      },
    }
  );
  return res;
}

export const SEARCH_PAGE_SIZE = 10;

export async function searchArticles(
  term: string,
  languageId: string,
  offset: number = 0
) {
  const res = await query<SearchQuery, SearchQueryVariables>(ARTICLE_SEARCH, {
    pageUrl: window.location.toString(),
    languageId,
    query: {
      paging: {
        first: SEARCH_PAGE_SIZE,
        offset,
      },
      terms: term,
    },
  });
  return res;
}
